<template>
    <div
        v-if="isVisible"
        class="cookie_notice"
    >
        <p class="cookie_notice_text">
            Мы используем cookie и похожие технологии для корректной работы сайта, улучшения сервиса и анализа посещаемости.
            Продолжая использовать сайт или нажимая «Согласен», вы соглашаетесь с обработкой cookie в соответствии с
            <a
                href="/privacy-policy.html"
                class="cookie_notice_link"
                target="_blank"
                rel="noopener noreferrer"
            >
                политикой конфиденциальности
            </a>.
        </p>
        <button
            class="cookie_notice_button"
            type="button"
            @click="acceptCookies"
        >
            Согласен
        </button>
    </div>
</template>

<script>
const COOKIE_NOTICE_KEY = 'cookie_notice_accepted';

export default {
    name: 'CookieNotice',
    data () {
        return {
            isVisible: false,
        };
    },
    mounted () {
        this.isVisible = localStorage.getItem(COOKIE_NOTICE_KEY) !== 'true';
    },
    methods: {
        acceptCookies () {
            localStorage.setItem(COOKIE_NOTICE_KEY, 'true');
            this.isVisible = false;
        },
    },
};
</script>

<style scoped>
.cookie_notice {
    position: fixed;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    max-width: 52rem;
    margin: 0 auto;
    padding: 0.9rem 1rem;
    border: 0.05rem solid rgba(220, 102, 64, 0.45);
    border-radius: 0.4rem;
    box-shadow: 0 0.6rem 1.8rem rgba(25, 25, 25, 0.22);
    background: rgba(25, 25, 25, 0.95);
}

.cookie_notice_text {
    color: rgb(245, 245, 245);
    font-family: Montserrat_Medium;
    font-size: 0.7rem;
    font-weight: 500;
    line-height: 1rem;
}

.cookie_notice_link {
    color: rgb(238, 217, 176);
    text-decoration: underline;
}

.cookie_notice_button {
    flex: 0 0 auto;
    min-width: 7rem;
    height: 2.4rem;
    padding: 0 1rem;
    border-radius: 0.25rem;
    background: rgb(220, 102, 64);
    color: rgb(245, 245, 245);
    font-family: Montserrat_SemiBold;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 0.9rem;
}

@media (max-width: 768px) {
    .cookie_notice {
        flex-direction: column;
        align-items: stretch;
    }

    .cookie_notice_button {
        width: 100%;
    }
}
</style>
